import accountLookupFormMixin from "./accountLookupFormMixin";
import mixins from "vue-typed-mixins";
import { featureToggleMixin, gtmMixin } from "@/mixins";
import { Collapsible, Card, Hyperlink, Button } from "@/components";
import accountLookupResultMixin from "./accountLookupResultMixin";
const CardStep = () => import("./CardStep.vue");
const ModalAccountCreation = () => import("./ModalAccountCreation.vue");
const ModalAccountCreationSuccess = () => import("./ModalAccountCreationSuccess.vue");
export default mixins(accountLookupFormMixin, featureToggleMixin, accountLookupResultMixin, gtmMixin).extend({
    components: {
        Card,
        Hyperlink,
        CardStep,
        Button,
        Collapsible,
        ModalAccountCreation,
        ModalAccountCreationSuccess,
    },
    props: {
        error: {
            type: Object,
            default: null,
        },
    },
    data: () => ({
        isModalCreationOpen: false,
        isModalInfoOpen: false,
    }),
    computed: {
        canRequestAccount() {
            return this.result && !this.firstAccount && this.TOGGLES.accountCreation;
        },
        isCaptchaError() {
            var _a;
            return ((_a = this.error) === null || _a === void 0 ? void 0 : _a.code) === 401;
        },
        guideHowToActivate() {
            return `
1. Membuka laman http://pd.data.kemdikbud.go.id/
2. Kemudian login menggunakan akun SSO Data Pokok Pendidikan (Dapodik) yang terdaftar di http://sdm.data.kemdikbud.go.id
3. Klik tombol “**Unduh Akun**”, lalu pilih “**Peserta Didik**” atau “**PTK**” untuk mengunduh data  berisi nama akun (User ID) dan  kata sandi akun (password) dalam format .csv.
4. Buka data berformat .csv tersebut, kemudian berikan informasi akun berupa User ID dan kata sandi atau password kepada pengguna. Pastikan informasi akun tersebut hanya  diberikan kepada pengguna yang datanya ada di Data Pokok Pendidikan (Dapodik).`;
        },
        emailHref() {
            const subject = "[belajar.id] Tanya tentang Akun Pembelajaran";
            const body = `Untuk mempermudah kami menjawab pertanyaan Anda, silakan tulis sesuai format:%0d%0a
• Nama Lengkap (sesuai Dapodik):%0d%0a
• Nama Sekolah:%0d%0a
• Jenjang (contoh SD):%0d%0a
• Tipe Akun (contoh : Peserta Didik, Pendidik dan Tenaga Kependidikan )%0d%0a
• NPSN:%0d%0a
• Nomor handphone (yang terdaftar di Dapodik):%0d%0a
• Akun Pembelajaran/email Akun Pembelajaran Akses Layanan Pembelajaran (jika ada):%0d%0a
• Topik pertanyaan (contoh : 3) pilih salah satu:%0d%0a
  1. Status dan aktivasi akun%0d%0a
  2. Reset/ganti password%0d%0a
  3. Permintaan pembuatan akun%0d%0a
  4. Chromebook%0d%0a
  5. Lainnya%0d%0a
• Detail Pertanyaan (mohon tuliskan masalah yang Anda alami dengan detail):%0d%0a
%0d%0a
*Jam operasional layanan bantuan adalah Senin-Jumat pukul 08:00 - 15:00, pertanyaan yang masuk di luar jam operasional akan ditanggapi di hari dan jam kerja berikutnya
`;
            return `mailto:pengaduan@kemdikbud.go.id?subject=${subject}&body=${body}&Content-Type=text/html`;
        },
    },
    methods: {
        onAccountCreationSuccess() {
            this.isModalCreationOpen = false;
            this.isModalInfoOpen = true;
        },
        openModalAccountCreation() {
            this.isModalCreationOpen = true;
        },
        trackEmail() {
            this.gtmClickButton("aduan_ult");
        },
    },
});
